import { render, staticRenderFns } from "./MobileBottomMenu.vue?vue&type=template&id=63cf8bfb&lang=pug&"
import script from "./MobileBottomMenu.vue?vue&type=script&lang=js&"
export * from "./MobileBottomMenu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports